(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ar-brand-spotlight"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (root.dataset.spotReady) return;
    root.dataset.spotReady = '1';
    // no animation: mark the section entered so the end state (incl. the link
    // underline) renders straight away
    if (reduce || !('IntersectionObserver' in window)) {
      root.classList.add('is-in', 'is-settled');
      return;
    }

    root.classList.add('js-spot');
    var layer = root.querySelector('[data-ar-spot-parallax]');
    var stage = root.querySelector('.ar-spot__stage');
    var ticking = false;

    // gentle drift: the stage image travels ~6% against the scroll
    function drift() {
      ticking = false;
      if (!layer || !stage) return;
      var r = stage.getBoundingClientRect();
      var vh = window.innerHeight;
      if (r.bottom < 0 || r.top > vh) return;
      var p = (r.top + r.height / 2 - vh / 2) / (vh / 2 + r.height / 2); // -1 … 1
      root.style.setProperty('--spot-y', (p * r.height * 0.05).toFixed(1) + 'px');
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(drift); } }

    // The scroll listener starts with the entrance, not after it: the 1.9s
    // transition simply retargets as --spot-y moves, so there is no stale
    // offset for the image to snap to when the transition is switched off.
    var started = false;
    function start() {
      if (started) return;
      started = true;
      io.disconnect();
      drift();
      window.addEventListener('scroll', onScroll, { passive: true });
      root.classList.add('is-in');
      setTimeout(function () { root.classList.add('is-settled'); }, 2000);
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) start(); });
    }, { threshold: 0.18 });
    io.observe(root);

    // never leave the section hidden if the observer is starved (e.g. print, odd embeds)
    setTimeout(function () {
      if (root.getBoundingClientRect().top < window.innerHeight) start();
    }, 3000);
  }

  function boot() { document.querySelectorAll('[data-ar-spot]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-ar-spot]');
    if (el) { init(el); el.classList.add('is-in', 'is-settled'); }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
